import React from 'react'
import { useRecoilState } from 'recoil'

import { RefundTypeState } from '@/features/support/refund/store'
import { BankList } from '@/shared/constant'
import { OptionCustom, SelectCustom, SelectFormWrap } from '@/styles/common/CommonForm/selectform'

const SelectForm = (props: any) => {
  const { title } = props
  const [refundType, setRefundType] = useRecoilState(RefundTypeState)

  const selectOption = [
    { idx: 0, value: 'none', text: '은행을 선택해주세요.' },
    ...BankList.map((bank, index) => ({
      idx: index + 1,
      value: bank,
      text: bank,
    })),
  ]

  return (
    <SelectFormWrap style={props?.style}>
      <p>{title}</p>
      <SelectCustom
        defaultValue="none"
        onChange={(e) => {
          setRefundType(e.target.value)
        }}
        color={`${refundType !== 'none' && 'active'}`}
      >
        {selectOption.map((element: any) => (
          <React.Fragment key={element.idx}>
            {element.value === 'none' ? (
              <OptionCustom disabled hidden value="none">
                {element.text}
              </OptionCustom>
            ) : (
              <OptionCustom value={element.value}>{element.text}</OptionCustom>
            )}
          </React.Fragment>
        ))}
      </SelectCustom>
    </SelectFormWrap>
  )
}
export default SelectForm
